import React from 'react';
import { togglePackingItem, downloadChecklistText, triggerDownload } from '../../data/journeys/journeyProgress';

function PackingChecklistPanel({ journey, progress, onProgressUpdate }) {
	const items = journey.packingChecklist || [];
	const done = items.filter((i) => progress.packing[i.id]).length;
	const slug = journey.slug;

	const categories = [...new Set(items.map((i) => i.category))];

	return (
		<div className="guided-panel guided-panel--packing">
			<h3 className="guided-panel__title">Packing checklist</h3>
			<p className="guided-panel__intro">
				{done}/{items.length} items packed · October trek
			</p>

			{categories.map((cat) => (
				<div key={cat} className="guided-packing__category">
					<h4>{cat}</h4>
					<ul className="guided-packing__list">
						{items.filter((i) => i.category === cat).map((item) => (
							<li key={item.id}>
								<label className="guided-packing__item">
									<input
										type="checkbox"
										checked={!!progress.packing[item.id]}
										onChange={() => onProgressUpdate(togglePackingItem(slug, item.id))}
									/>
									<span className="guided-packing__body">
										<strong>{item.label}</strong>
										<span className="guided-packing__meta">
											{item.weight}
											{item.buyAtHome && ` · Buy at home: ${item.buyAtHome}`}
											{item.rentKtm && ` · Rent KTM: ${item.rentKtm}`}
											{item.needOct === false && ' · Optional in October'}
										</span>
									</span>
								</label>
							</li>
						))}
					</ul>
				</div>
			))}

			<div className="guided-packing__notes">
				<p><strong>October temps:</strong> Namche 0–5°C nights · Lobuche/Gorak Shep -10 to -20°C · Crampons not needed · Gaiters optional</p>
			</div>

			<button
				type="button"
				className="guided-panel__download"
				onClick={() => triggerDownload(`${slug}-packing-checklist.txt`, downloadChecklistText(journey, progress))}
			>
				Download checklist PDF (text)
			</button>
		</div>
	);
}

export default PackingChecklistPanel;
